import React from 'react';

/**
 * SubTabBar — pill-style sub-tabs that sit under the main TabBar.
 * Use for filter / range selectors inside a tab.
 * Items: [{ id, label, badge? }]
 */
export function SubTabBar({ items = [], value, onChange, className = '' }) {
  return (
    <div
      className={
        'inline-flex items-center gap-1 p-1 rounded-lg border border-ink-200/70 dark:border-ink-800/70 ' +
        'bg-white/40 dark:bg-ink-900/30 text-[12px] ' +
        className
      }
    >
      {items.map((item) => {
        const active = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange?.(item.id)}
            className={
              'px-3 py-1 rounded-md transition-all duration-150 ' +
              (active
                ? 'bg-ink-900 dark:bg-ink-50 text-white dark:text-ink-900'
                : 'text-ink-500 hover:bg-ink-100/60 dark:hover:bg-ink-800/60')
            }
          >
            {item.label}
            {item.badge != null ? (
              <span className="ml-1.5 nums text-[10px] opacity-70">{item.badge}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
export default SubTabBar;
